<template>
  <div class="ui_hotelRoom_box" :style="styleBg">
  <div class="ui_hotelRoom" @click="goHotelList" v-bind:class="{noShadow:datas.shadow=='normal'}" >
    <div class="searchBox" v-if="datas.showSearch">
      <i class="iconfont iconsousuo"></i>
      <div class="inputBox">搜索地点/酒店民宿/关键词</div>
    </div>
    <div class="calendarBox">
      <div class="timerBox">
        <p class="timeTitle">入住日期</p>
        <div class="timeDetails">
          <p class="dayTime">{{checkInDay}}</p>
          <p class="weekTime">{{checkInTime}}</p>
        </div>
      </div>
      <div class="timerMiddleBox">
        <em class="line">{{ zday }}晚</em>
      </div>
      <div class="timerBox right">
        <p class="timeTitle">离店日期</p>
        <div class="timeDetails">
          <p class="dayTime">{{checkOutDay}}</p>
          <p class="weekTime">{{checkOutTime}}</p>
        </div>
      </div>
    </div>
    <div class="bookBtn" v-bind:class="{circular:datas.buttonType=='circular'}" :style="btnStyle">立即订房</div>
  </div>
</div>
</template>

<script>
import moment from "moment";

moment.locale("en", {
  weekdays: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
});

export default {
  name: "hotelRoom",
  props: ["datas"],
  data() {
    return {
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().add(1, "days").format("YYYY-MM-DD"),
    };
  },
  computed: {
    btnStyle(){
      if(this.datas.btColor){
        return `background:${this.datas.btColor};`
      }else{
        return ""
      }
      
    },
    styleBg(){
      return `background:${this.datas.bgColor};`
    },
    zday() {
      let arr = moment(this.fromDate);
      let dep = moment(this.toDate);
      let zday = dep.diff(arr, "d");
      return zday;
    },
    checkInDay() {
      return moment(this.fromDate).format("MM月DD日");
    },
    checkOutDay() {
      return moment(this.toDate).format("MM月DD日");
    },
    checkInTime() {
      return moment(this.fromDate).format("dddd");
    },
    checkOutTime() {
      return moment(this.toDate).format("dddd");
    },
  },
  components: {},
  methods: {
    goHotelList() {
      if(this.datas&&this.datas.link){
        this.goLink(this.datas.link);
        return false;
      }
      window.location.href = `/wechat/?/#/hotelListNew?otaChannel=WECHAT`;
    },
  },
};
</script>
<style lang="less" scoped>
@import url("~@/styles/mixin.less");
.ui_hotelRoom_box{
  padding-bottom: 15px;
  
}
.ui_hotelRoom {
  padding: 0 15px 15px 15px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 6px 12px 0px rgba(48, 48, 48, 0.1);
  width: calc(~"100vw - 0.8rem");
  box-sizing: border-box;
  margin: 0 auto;

  &.noShadow{
    box-shadow:initial;
  }
  .searchBox {
    display: flex;
    align-items: center;
    height: 48px;
    color: #999999;
    position: relative;
    &:before {
      content: "";
      position: absolute;
      width: 200%;
      height: 1px;
      bottom: 0;
      border-bottom: 1px solid rgba(227, 227, 227, 1);
      -webkit-transform-origin: 0 0;
      transform-origin: 0 0;
      -webkit-transform: scale(0.5, 0.5);
      transform: scale(0.5, 0.5);
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
    }
    .inputBox {
      margin-left: 10px;
    }
  }
  .calendarBox {
    height: 70px;
    display: flex;
    align-items: center;
    .timerBox {
      flex: 1;
      &.right {
        text-align: right;
        .timeDetails {
          justify-content: flex-end;
        }
      }
      .timeTitle {
        font-size: 12px;
        color: #999999;
      }
      .timeDetails {
        display: flex;
        margin-top: 8px;
        color: #333333;
        align-items: baseline;
        .dayTime {
          font-size: 15px;
          font-weight: bold;
        }
        .weekTime {
          font-size: 12px;
          margin-left: 5px;
        }
      }
    }
    .timerMiddleBox {
      em {
        border: 1px solid rgba(204, 204, 204, 0.5);
        border-radius: 9px;
        height: 16px;
        width: 45px;
        line-height: 16px;
        text-align: center;
        height: 16px;
        width: 45px;
        line-height: 16px;
        text-align: center;
        font-size: 12px;
        color: #333333;
        font-weight: bold;
        display: block;
      }
    }
  }
  .bookBtn {
    background: @color-theme;
    border-radius: 4px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    font-size: 15px;
    color: #ffffff;
    font-weight: bold;
    &.circular{
      border-radius: 19px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/polymerization/hotelRoom.vue